import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import Clickable from "@insite/mobius/Clickable";
import { useState } from "react";
import { loyaltyRewards } from "@NA/Widgets/LoyaltyRewards/LoyaltyStyles";
import CircularProgressBar from "@NA/Widgets/LoyaltyRewards/CircularProgressBar";
import TooltipComponent from "@NA/Widgets/LoyaltyRewards/LoyaltyTooltip";
import ADIProrewardsandsuppliers from "@NA/Widgets/LoyaltyRewards/ADIProrewardsandsuppliers";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIExclusiveBrands from "@NA/Widgets/LoyaltyRewards/ADIExclusiveBrands";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { Hidden } from "@insite/mobius/index";
import ADIRewardsLogo from "@NA/Icons/ADIRewardsLogo";
import { fomratLoyaltyPoints, convertPercentage, remainingSpendGoal, checkVaildUserForHmiRewards, formatUTCTime } from "@NA/Utils/Utility";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link from "@insite/mobius/Link";
import RewardsInfoIcon from "@NA/Icons/RewardsInfoIcon";
import siteMessage from "@insite/client-framework/SiteMessage";

let styles = loyaltyRewards;

interface OwnProps {
    loyaltyModel: boolean;
    closePopup: Function;
}

export const LoyaltyRewards = ({ loyaltyModel = true, closePopup }: OwnProps) => {
    styles = loyaltyRewards?.LoyaltyRewardsStyle;
    const rewardsRef = useRef<HTMLDivElement>(null);
    const loyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData.loyaltyRewardStore.loyalty);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
    const loyaltyStateStore = useSelector((state: CustomApplicationState) => state.ADIGlobalData.loyaltyRewardStore);
    const currentCurrencySymbol = useSelector(
        (state: CustomApplicationState) => state.context.session.currency?.currencySymbol,
    );
    const history = useHistory();
    const loadingSpinner = useSelector(
        (state: CustomApplicationState) => state?.ADIGlobalData?.loyaltyRewardStore.isLoading,
    );

    const dispatch = useDispatch();

    const [isLoyaltyModalOpen, setIsLoyaltyModalOpen] = useState(false);
    const closeLoyaltyModal = () => {
        setIsLoyaltyModalOpen(false);
    };
    const openLoyaltyModal = () => {
        setIsLoyaltyModalOpen(true);
    };
    const [isOpenSupplierModal, setIsOpenSupplierModal] = useState(false);
    const closeSupplierModal = () => {
        setIsOpenSupplierModal(false);
    };
    const openSupplierModal = () => {
        setIsOpenSupplierModal(true);
    };
    const progressValue = convertPercentage(loyaltyState.currentPercentToGoal);

    const isValidHmiUser = checkVaildUserForHmiRewards(loyaltyState);

    const handleScrollToRewardsView = () => {
        const element = document.querySelector('[data-test-selector="rewards"]');
        const elementHeader = document.querySelector('[data-test-selector="header"]');
        if (element && elementHeader) {
            const elementRect = element.getBoundingClientRect();
            const elementRectHeader = elementHeader.getBoundingClientRect();
            setTimeout(() => {
                window.scrollTo({
                    top: elementRect.top + window.scrollY - elementRectHeader.height - 20,
                    behavior: "smooth",
                });
            }, 20);
        }
    };

    const handleScrollToRewards = () => {
        if (!loyaltyModel) {
            closePopup();
            if (window.location.pathname != "/myaccount") {
                dispatch({
                    type: "AccountPage/RouteUpdate",
                });
            } else {
                handleScrollToRewardsView();
            }
        } else {
            handleScrollToRewardsView();
        }
    };

    useEffect(() => {
        if (loyaltyStateStore.isAdIProRewardsLoaded) {
            setTimeout(() => {
                handleScrollToRewardsView();
            }, 20);
            dispatch({
                type: "AccountPage/ProRewardReset",
            });
        }
    }, [loyaltyStateStore]);

    useEffect(() => {
        if (loyaltyStateStore.isMyAccountPageReloaded) {
            setTimeout(() => {
                handleScrollToRewardsView();
            }, 100);
        }
        return () => {
            if (loyaltyStateStore.isMyAccountPageReloaded) {
                setTimeout(() => {
                    dispatch({
                        type: "AccountPage/RouteDeactivate",
                    });
                }, 3000);
            }
        };
    }, []);

   
    return (
        <>
            {(isProRewardsUser && loadingSpinner) ? (
                <LoadingSpinner size={15} style={{ position: "absolute", right: "50%" }} />
            ) : (
                <>
                    {
                        <>
                            {styles && isProRewardsUser && isValidHmiUser && (
                                <>
                                    <StyledWrapper ref={rewardsRef} data-test-selector="rewards">
                                        <GridContainer
                                            {...(loyaltyModel ? styles.gridContainer : styles.gridContainermodal)}
                                        >
                                            <GridItem
                                                {...(loyaltyModel ? styles.GridItem : styles.GridItemLogo)}
                                                width={loyaltyModel ? [12, 12, 12, 2, 2] : [12]}
                                            >
                                                <Clickable href="/myaccount" onClick={handleScrollToRewards}>
                                                    <ADIRewardsLogo />
                                                </Clickable>
                                            </GridItem>
                                            <GridItem
                                                {...(loyaltyModel ? styles.GridItem : styles.hideElements)}
                                                width={loyaltyModel ? [12, 12, 12, 10, 10] : [12]}
                                                className="loyaltylandingtitle"
                                            >
                                                <Typography {...styles.loyaltyTitleText}>
                                                    {" "}
                                                    {translate("Current Quarter Overview")}
                                                </Typography>
                                                <Typography {...styles.loyaltyTitledate}>
                                                    {" "}
                                                    {loyaltyState && loyaltyState.rewardsQuarter}
                                                </Typography>
                                            </GridItem>
                                            <StyledWrapper
                                                {...(loyaltyModel ? styles.loyaltyBorder : styles.hideElements)}
                                            ></StyledWrapper>

                                            <GridItem
                                                {...(loyaltyModel
                                                    ? styles.leftColumnWrapper
                                                    : styles.leftColumnWrapperModal)}
                                                width={loyaltyModel ? [12, 12, 12, 5, 5] : [6]}
                                            >
                                                <GridItem
                                                    {...(loyaltyModel
                                                        ? styles.hideElements
                                                        : styles.GridItemModalTitle)}
                                                    width={loyaltyModel ? [12, 12, 12, 8, 8] : [12]}
                                                    className="loyaltymodaltitle"
                                                >
                                                    <Typography {...styles.loyaltyTitleTextModal}>
                                                        {" "}
                                                        {translate("Current Quarter Overview")}
                                                    </Typography>
                                                    <Typography {...styles.loyaltyTitledateModal}>
                                                        {" "}
                                                        {loyaltyState && loyaltyState.rewardsQuarter}
                                                    </Typography>
                                                </GridItem>
                                                <Hidden
                                                    {...(loyaltyModel
                                                        ? styles.hideElementsMob
                                                        : styles.loyaltyProgressModal)}
                                                >
                                                    <Typography
                                                        {...(loyaltyModel
                                                            ? styles.titleGridItem
                                                            : styles.titleGridItemModal)}
                                                    >
                                                        {" "}
                                                        {translate("Progress To Goal")}
                                                    </Typography>
                                                </Hidden>
                                                <Hidden below="sm" {...styles.hideElementsMob}>
                                                    <Typography
                                                        {...(loyaltyModel
                                                            ? styles.subtitleGridItem
                                                            : styles.hideElements)}
                                                    >
                                                        {translate("Earn")}
                                                        <strong>{translate("1 Point")}</strong>
                                                        {translate("for Every Dollar Spent at ADI")}
                                                    </Typography>
                                                </Hidden>

                                                <GridContainer
                                                    {...(loyaltyModel
                                                        ? styles.leftColumnContainer
                                                        : styles.leftColumnModal)}
                                                >
                                                    <GridItem
                                                        width={loyaltyModel ? [12, 12, 5, 6, 6] : [6]}
                                                        {...(loyaltyModel
                                                            ? styles.GridItem
                                                            : styles.leftColumnModalGrid)}
                                                    >
                                                        <GridItem {...styles.loyaltyTotalSpend}>
                                                            <Typography {...styles.loyaltyLabelText}>
                                                                {" "}
                                                                {translate("Total ADI Spend")}
                                                            </Typography>
                                                            <Typography {...styles.loyaltyValueText}>
                                                                {" "}
                                                                {loyaltyState &&
                                                                    fomratLoyaltyPoints(
                                                                        loyaltyState.currentPurchases,
                                                                        currentCurrencySymbol,
                                                                    )}
                                                            </Typography>
                                                        </GridItem>
                                                        <GridItem {...styles.loyaltyRemainingSpend}>
                                                            <Typography {...styles.loyaltyLabelText}>
                                                                {" "}
                                                                {translate("Remaining Spend to Goal*")}
                                                            </Typography>
                                                            <Typography {...styles.loyaltyValueText}>
                                                                {" "}
                                                                {loyaltyState &&
                                                                    remainingSpendGoal(
                                                                        loyaltyState.currentGoal,
                                                                        loyaltyState.currentPurchases,
                                                                        currentCurrencySymbol,
                                                                    )}
                                                            </Typography>
                                                        </GridItem>
                                                    </GridItem>
                                                    <GridItem
                                                        {...(loyaltyModel
                                                            ? styles.progressBar
                                                            : styles.progressBarModel)}
                                                        width={[12, 12, 5, 6, 6]}
                                                    >
                                                        <StyledWrapper
                                                            {...(loyaltyModel
                                                                ? styles.circularProgressBar
                                                                : styles.circularProgressBarModal)}
                                                        >
                                                            <CircularProgressBar ProgressValue={progressValue} />
                                                        </StyledWrapper>
                                                        <GridItem
                                                            width={loyaltyModel ? [12, 12, 8, 8, 8] : [12]}
                                                            {...styles.GridItem}
                                                        >
                                                            <Typography
                                                                {...(loyaltyModel
                                                                    ? styles.loyaltyLabelText
                                                                    : styles.loyaltyLabelTextModal)}
                                                            >
                                                                {" "}
                                                                {translate("Goal")}
                                                            </Typography>
                                                            <Typography
                                                                {...(loyaltyModel
                                                                    ? styles.loyaltyValueText
                                                                    : styles.loyaltyValueTextModal)}
                                                            >
                                                                {loyaltyState &&
                                                                    fomratLoyaltyPoints(
                                                                        loyaltyState.currentGoal,
                                                                        currentCurrencySymbol,
                                                                    )}
                                                            </Typography>
                                                            <Typography
                                                                {...(loyaltyModel
                                                                    ? styles.loyaltyLabelText
                                                                    : styles.loyaltyLabelTextModal)}
                                                            >
                                                                {" "}
                                                                {translate("% to Goal")}
                                                            </Typography>
                                                            <Typography
                                                                {...(loyaltyModel
                                                                    ? styles.loyaltyValueText
                                                                    : styles.loyaltygoalValueTextModal)}
                                                                {...(loyaltyModel
                                                                    ? styles.loyaltyValueTextpercentage
                                                                    : styles.loyaltygoalValueTextModal)}
                                                            >
                                                                {" "}
                                                                {convertPercentage(progressValue.toString())}
                                                            </Typography>
                                                        </GridItem>
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>

                                            <GridItem
                                                {...(loyaltyModel ? styles.rightColumnWrapper : styles.hideElements)}
                                                width={[12, 12, 12, 5, 5]}
                                            >
                                                <Typography {...styles.titleGridItem}>
                                                    <TooltipComponent />
                                                </Typography>
                                                <Typography {...styles.subtitleGridItem}>
                                                    {translate("Earn up to")}
                                                    <strong>{translate("2 Extra Points")}</strong>
                                                    {translate("for Every Dollar Spent at ADI")}
                                                </Typography>

                                                <GridContainer {...styles.rightColumnContainer}>
                                                    <GridItem
                                                        width={loyaltyModel ? [12, 12, 4, 4, 4] : [12]}
                                                        {...styles.loyaltyGridItem}
                                                    >
                                                            <Typography {...styles.rightColumnAppsend} > {translate("Online and App Spend")} </Typography>
                                                         <Typography>
                                                            {translate("Earn")}
                                                            <strong>{translate("1 Extra")}</strong>
                                                            {translate("Point")}
                                                        </Typography>
                                                        <Typography {...styles.loyaltyValueText}>
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(
                                                                    loyaltyState.currentOnline,
                                                                    currentCurrencySymbol,
                                                                )}{" "}
                                                        </Typography>
                                                        <Clickable onClick={() => history.push("/")}>
                                                            {" "}
                                                            {translate("Shop Now")}
                                                        </Clickable>
                                                    </GridItem>
                                                    <GridItem
                                                        width={loyaltyModel ? [12, 12, 4, 4, 4] : [12]}
                                                        {...styles.loyaltyGridItem}
                                                    >
                                                        <Typography>
                                                            {" "}
                                                            {translate("ADI Exclusive Brands Spend")}
                                                        </Typography>
                                                        <Typography>
                                                            {translate("Earn")}
                                                            <strong>{translate("1 Extra")}</strong>
                                                            {translate("Point")}
                                                        </Typography>
                                                        <Typography {...styles.loyaltyValueText}>
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(
                                                                    loyaltyState.currentPrivate,
                                                                    currentCurrencySymbol,
                                                                )}
                                                        </Typography>
                                                        <Clickable onClick={openLoyaltyModal}>
                                                            {translate("ADI Exclusive Brands")}
                                                        </Clickable>
                                                    </GridItem>
                                                    <GridItem
                                                        width={loyaltyModel ? [12, 12, 4, 4, 4] : [12]}
                                                        {...styles.loyaltyGridItem}
                                                    >
                                                        <Typography>
                                                            {" "}
                                                            {translate("Featured Suppliers Spend")}{" "}
                                                        </Typography>
                                                        <Typography>
                                                            {translate("Earn")}
                                                            <strong>{translate("1 Extra")}</strong>
                                                            {translate("Point")}
                                                        </Typography>
                                                        <Typography {...styles.loyaltyValueText}>
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(
                                                                    loyaltyState.currentFeatured,
                                                                    currentCurrencySymbol,
                                                                )}
                                                        </Typography>
                                                        <Clickable onClick={openSupplierModal}>
                                                            {" "}
                                                            {translate("Featured Suppliers")}{" "}
                                                        </Clickable>
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>

                                            <GridItem
                                                width={[12, 12, 12, 8, 8]}
                                                {...(loyaltyModel ? styles.infoMsgGridItem : styles.hideElements)}
                                            >
                                                <Typography {...(loyaltyModel ? styles.rewardsInfoIconNotes : styles.rewardsInfoIconhide)}>
                                                    <RewardsInfoIcon />
                                                </Typography>
                                                <Typography {...styles.loyaltyNotes}>

                                                    {" "}
                                                    {siteMessage("Rewards_Info_Message")}
                                                </Typography>
                                                <Typography {...styles.loyaltyNotes}>
                                                    {" "}
                                                    {translate("Last refreshed on")}
                                                    {" "}
                                                    {loyaltyState &&
                                                        formatUTCTime(loyaltyState.lastRefreshedDateTime)}
                                                </Typography>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer
                                            {...(loyaltyModel ? styles.loyaltyContainer : styles.loyaltyContainerModal)}
                                        >
                                            <GridItem width={12}>
                                                <GridItem
                                                    width={loyaltyModel ? [12, 12, 12, 2, 2] : [12]}
                                                    className="loyaltymypoints"
                                                >
                                                    <Typography variant="h5">{translate("My Points")}</Typography>
                                                </GridItem>
                                                    <GridItem width={loyaltyModel ? [12, 12, 12, 8, 8] : [12]} {...(loyaltyModel ? styles.loyaltymypointsContainer : "")} >
                                                    <GridItem width={12} {...(loyaltyModel
                                                                ? styles.loyaltyLabelgrid
                                                                : styles.loyaltyLabelgridModel)}>
                                                        <Typography
                                                            {...(loyaltyModel
                                                                ? styles.loyaltyLabelText
                                                                : styles.loyaltyPendPointsText)}
                                                        ><Typography {...(loyaltyModel ? styles.rewardsInfoIconPending : styles.rewardsInfoIconhide)}>
                                                                <RewardsInfoIcon />
                                                            </Typography>
                                                            {" "}
                                                            {translate("Pending")}
                                                        </Typography>
                                                        <Typography
                                                            {...(loyaltyModel
                                                                ? styles.loyaltyValueText
                                                                : styles.loyaltyPendPointsText)}
                                                        >
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(loyaltyState.currentPending, "")}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem
                                                        width={12}
                                                        {...(loyaltyModel
                                                            ? styles.loyaltyLabelgrid
                                                            : styles.hideElements)}
                                                    >
                                                        <Typography {...styles.loyaltyLabelText}>
                                                            {" "}
                                                            {translate("Earned")}
                                                        </Typography>
                                                        <Typography {...styles.loyaltyValueText}>
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(loyaltyState.earned, "")}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem
                                                        width={12}
                                                        {...(loyaltyModel
                                                            ? styles.loyaltyLabelgrid
                                                            : styles.hideElements)}
                                                    >
                                                        <Typography {...styles.loyaltyLabelText}>
                                                            {" "}
                                                            {translate("Redeemed")}
                                                        </Typography>
                                                        <Typography {...styles.loyaltyValueText}>
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(loyaltyState.redeemed, "")}
                                                        </Typography>
                                                    </GridItem>
                                                    <GridItem
                                                        width={12}
                                                        className="mypointsavailable"
                                                        {...(loyaltyModel
                                                            ? styles.loyaltyLabelgrid
                                                            : styles.loyaltyLabelgridModel)}>
                                                        <Typography
                                                            {...(loyaltyModel
                                                                ? styles.loyaltyLabelText
                                                                : styles.loyaltyAvailPointsText)}
                                                        >
                                                            {" "}
                                                            {translate("Available")}
                                                        </Typography>
                                                        <Typography
                                                            {...(loyaltyModel
                                                                ? styles.loyaltyValueText
                                                                : styles.loyaltyAvailPointsText)}
                                                        >
                                                            {" "}
                                                            {loyaltyState &&
                                                                fomratLoyaltyPoints(loyaltyState.balance, "")}
                                                        </Typography>
                                                    </GridItem>
                                                </GridItem>
                                                <GridItem
                                                    {...(loyaltyModel ? styles.hideElements : styles.loyaltyDetailGrid)}
                                                >
                                                    <Typography className="loyaltyseedetails">
                                                    <Clickable
                                                        {...(loyaltyModel
                                                            ? styles.hideElements
                                                            : styles.loyaltySeedetailBtn)}
                                                        href="/myaccount"
                                                        onClick={handleScrollToRewards}
                                                    >
                                                        {" "}
                                                        {translate("See Details")}{" "}
                                                    </Clickable>
                                                    </Typography>
                                                </GridItem>
                                                <GridItem width={[12, 12, 12, 2, 2]} {...(loyaltyModel ? styles.browseAndRedeem : styles.browseAndRedeemModal)} className="reedeembtn" 
                                                >
                                                    <Clickable
                                                        {...(loyaltyModel ? styles.loyaltyRedeemBtn : styles.loyaltyRedeemBtnModal)}

                                                        href="/api/v1/singlesignon/signin" target="_blank" data-ga-promo="ADI-loyalty_Browse-Redeem"
                                                    
                                                    >
                                                        {" "}
                                                        {translate("Browse and Redeem")}{" "}
                                                    </Clickable>
                                                </GridItem>
                                            </GridItem>
                                        </GridContainer>
                                    </StyledWrapper>
                                </>
                            )}
                            <ADIExclusiveBrands
                                closeLoyaltyModal={closeLoyaltyModal}
                                isLoyaltyModalOpen={isLoyaltyModalOpen}
                            />
                            <ADIProrewardsandsuppliers
                                closeSupplierModal={closeSupplierModal}
                                isOpenSupplierModal={isOpenSupplierModal}
                            />
                        </>
                    }
                </>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: LoyaltyRewards,
    definition: {
        group: "My Account",
        displayName: "ADI Loyality",
        icon: "rewards",
    },
};

export default widgetModule;
